import { Injector, Pipe, PipeTransform } from '@angular/core';
import { upperFirst } from 'lodash';

import { CommonUtilitiesCore } from '../utilities/core.service';
import { CommonServerDateService } from '../server_date/server_date.service';
import { CommonNAFormatPipe } from './common-na-format/common-na-format.pipe';

export enum COMMON_DATE_PIPE_FORMAT_TYPE {
	SHORT = 'Short',
	MEDIUM = 'Medium',
	LONG = 'Long',
	TIME = 'Time',
	SHORT_WITH_TIME = 'ShortWithTime',
	MEDIUM_WITH_TIME = 'MediumWithTime',
	TIME_WITH_MEDIUM = 'TimeWithMedium',
	WEEK_DAY = 'WeekDay'
}

export interface ICommonDatePipeOptions {
	useCommonNAToBlankFormatter?: boolean;
	format?: string;
	formatType?: COMMON_DATE_PIPE_FORMAT_TYPE
}

@Pipe({
	name: 'commonDateFormatter',
})
export class CommonDatePipe implements PipeTransform {
	private commonServerDateService: CommonServerDateService = this.injector.get(CommonServerDateService);
	private getFormatStringForType (formatType: COMMON_DATE_PIPE_FORMAT_TYPE): string {
		switch (formatType) {
			case COMMON_DATE_PIPE_FORMAT_TYPE.SHORT:
				return this.commonServerDateService.shortDateFormat;
			case COMMON_DATE_PIPE_FORMAT_TYPE.MEDIUM:
				return this.commonServerDateService.mediumDateFormat;
			case COMMON_DATE_PIPE_FORMAT_TYPE.LONG:
				return this.commonServerDateService.longDateFormat;
			case COMMON_DATE_PIPE_FORMAT_TYPE.TIME:
				return this.commonServerDateService.displayTimeFormat;
			case COMMON_DATE_PIPE_FORMAT_TYPE.SHORT_WITH_TIME:
				return this.commonServerDateService.shortWithTime;
			case COMMON_DATE_PIPE_FORMAT_TYPE.MEDIUM_WITH_TIME:
				return this.commonServerDateService.mediumWithTime;
			case COMMON_DATE_PIPE_FORMAT_TYPE.TIME_WITH_MEDIUM:
				return this.commonServerDateService.timeWithMedium;
			case COMMON_DATE_PIPE_FORMAT_TYPE.WEEK_DAY:
				return this.commonServerDateService.weekDayFormat;
			default:
				return this.commonServerDateService.mediumDateFormat;
		}
	}

	constructor(
		private injector: Injector,
		private utilities: CommonUtilitiesCore,
		private commonNAFormatter: CommonNAFormatPipe,
	) {
	}

	transform(date: string | null, options: ICommonDatePipeOptions = {
		formatType: COMMON_DATE_PIPE_FORMAT_TYPE.MEDIUM,
		format: '',
		useCommonNAToBlankFormatter: false,
	}): string {
		if (!this.utilities.hasValue(date)) {
			return this.commonNAFormatter.transform(date, options.useCommonNAToBlankFormatter);
		}

		const formatType = options.formatType ?? COMMON_DATE_PIPE_FORMAT_TYPE.MEDIUM;
		const format = options.format || this.getFormatStringForType(formatType);

		return upperFirst(
			this.commonServerDateService
				.getDayjs(date)
				.format(format)
		);
	}
}
